/* eslint-disable react/display-name */
import React from 'react'
import styled from 'styled-components'
import { GrnData } from 'Store/grn/types'
import { formatDateTime, numberWithComma } from 'helpers/format'
import { TableListPage } from 'Components/common/Table'
import { PaymentItems } from 'Store/grn-payment/types'

type Props = {
  datas: PaymentItems[]
  onClickDetail?: (grnID: number) => void
}

const GrnListTable: React.FunctionComponent<Props> = props => {
  const { datas, onClickDetail = () => {} } = props

  const columns = [
    {
      title: 'เลขที่ใบจ่ายหนี้',
      dataIndex: 'grns',
      key: 'grn_no',
      render: (grn: GrnData) => <GrnNo onClick={() => onClickDetail(grn.id)}>{grn.grn_no}</GrnNo>,
    },
    {
      title: 'วันที่รับเข้าคลัง',
      dataIndex: 'grns',
      key: 'recieved_date',
      render: (grn: GrnData) => formatDateTime(grn.recieved_date || ''),
    },
    {
      title: 'ยอดที่ชำระ',
      dataIndex: 'price',
      key: 'price',
      render: (val: number) => numberWithComma(val, true),
    },
  ]

  return (
    <TableListPage columns={columns} datas={datas} isLoading={false} paginationContent={null} size="small" />
  )
}

const GrnNo = styled.div`
  cursor: pointer;
  text-decoration: underline;
`
export default GrnListTable
